import { render, staticRenderFns } from "./Kegiatan.vue?vue&type=template&id=12810997&"
import script from "./Kegiatan.vue?vue&type=script&lang=js&"
export * from "./Kegiatan.vue?vue&type=script&lang=js&"
import style0 from "./Kegiatan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports